export enum ParkInputStatus {
    FIRST_SMS_SENT = "Erste SMS gesendet",
    SECOND_SMS_SENT = "Zweite SMS gesendet",
    CAR_GONE = "Auto Abgefahren",
    CONFLICT = "KONFLICT",
}

export enum ProjectStatus {
    ACTIV = "Aktiv",
    INACTIV = "Inaktiv",
    ARCHIVED = "Archiviert",
}